import script from "./403.vue?vue&type=script&lang=ts&setup=true"
export * from "./403.vue?vue&type=script&lang=ts&setup=true"

import "./403.vue?vue&type=style&index=0&id=1923bc6d&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1923bc6d"]])

export default __exports__